module.exports = __webpack_public_path__ + "static/media/GeorgiaBallpark-Script.27104c29.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GeorgiaBallpark-Script.otf
// module id = 3185
// module chunks = 68